import globalText from "../../../../../utils/globalText";
import CommonLayout from "../../../../_utils/CommonLayout";
import Amount from "../../../../_utils/TransactionCommonComponents/Amount";
import PaymentMethodSelector from "../../../../_utils/TransactionCommonComponents/PaymentMethodSelector";

const ScheduleTransactionStepAmount = ({
  txnPayLoad,
  isNeft,
  isRtgs,
  slideAnimation,
  handleAmountChange,
  handleRtgsClick,
  handleNeftClick,
}) => {
  return (
    <div className="max-w-tab-width-normal w-width-full mx-auto py-padding-md px-padding-md Qlg:px-padding-base">
      <CommonLayout>
        <div className="w-width-full lg:max-w-[var(--create-box-width)]">
          <Amount
            title={globalText?.AMOUNT}
            amount={txnPayLoad?.amount}
            amountInWords={txnPayLoad?.amountInWords}
            copyData={null}
            onAmountChange={(val) =>
              handleAmountChange({
                name: "amount",
                value: val,
              })
            }
            onPasteApplied={() => {}}
            isPreview={false}
            txnPayLoad={txnPayLoad}
          />
        </div>

        <div className="w-width-full lg:max-w-[var(--create-box-width)]">
          <PaymentMethodSelector
            title={globalText?.SELECT_PAYMENT_METHOD}
            slideAnimation={slideAnimation}
            methods={[
              {
                key: "neft",
                label: globalText?.NEFT,
                subText: globalText?.NEFT_TRANSFER_NOTE,
                active: !!isNeft,
                notes: [
                  globalText?.TRANSACTION_EXECUTION_NOTE,
                  globalText?.TRANSACTION_LIMIT_NOTE,
                  globalText?.TRANSACTION_CHARGES_NOTE,
                ],
                onClick: handleNeftClick,
              },
              {
                key: "rtgs",
                label: globalText?.RTGS,
                subText: globalText?.INSTANT_TRANSFER_NOTE,
                active: !!isRtgs,
                notes: [
                  globalText?.RTGS_TRANSACTION_EXECUTION_NOTE,
                  globalText?.RTGS_TRANSACTION_LIMIT_NOTE,
                  globalText?.TRANSACTION_CHARGES_NOTE,
                ],
                onClick: handleRtgsClick,
              },
            ]}
          />
        </div>
      </CommonLayout>
    </div>
  );
};

export default ScheduleTransactionStepAmount;
